import { useSession } from "@/context/SessionContext";

// Canonical founder detection (mirrors useFounder in VaultStage7b). Governs the
// dev-phase feature locks: the Misteck Life "Coming Soon" intercept and the
// in-development Road Shooter / Space game route. NOTE: the platform user object
// exposes `role`/`handle`/`email` — there is NO `user.tier` or `user.meta` field.
const FOUNDER_HANDLE = "johnnywalker";
const FOUNDER_EMAIL = "djohnm1972@gmail.com";

export function useFounderGate() {
  const { user } = useSession();
  const isFounder =
    ["founder", "admin"].includes(user?.role) ||
    (user?.handle || "").toLowerCase() === FOUNDER_HANDLE ||
    (user?.email || "").toLowerCase() === FOUNDER_EMAIL;
  return { isFounder };
}
